const count = {
  path: '/count',
  name: 'count',
  icon: 'iconfont icon-tongji',
  component: () => import('@/pages/layout/appMain'),
  redirect: '/count/dataReport',
  children: [
    {
      name: 'detailData',
      icon: 'el-icon-document-copy',
      path: '/detailData',
      component: () => import('@/pages/count/detailData/detailData.vue')
    },
    {
      name: 'statistic',
      icon: 'el-icon-document-copy',
      path: '/statistic',
      component: () => import('@/pages/count/statistic/Statistic.vue')
    },
    // 增加导出任务
    {
      name: 'exportTask',
      icon: 'el-icon-upload',
      path: '/exportTask',
      component: () => import('@/pages/count/exportTask/exportTask.vue')
    }
  ]
}
export default count
